export default __webpack_public_path__ + "static/media/yandex-money.cb5f371b.svg";